<layout-with-nav [title]="title">
  <router-outlet router-outlet></router-outlet>
</layout-with-nav>
